var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.activeModal,{tag:"component",attrs:{"closeAfterSuccess":false},on:{"accept":function($event){++_vm.step}}})
}
var staticRenderFns = []

export { render, staticRenderFns }